<div class="dialogContainer">
  <div class="messageHolder">
    @if (warningMessage) {
      <div class="warningMessage">
        {{ warningMessage }}
      </div>
    }
    @if (errorMessage()) {
      <div class="errorMessage">
        {{ errorMessage() }}
      </div>
    }
  </div>
  <div class="content">
    <div class="displayRow">
      <label class="displayLabel">Order:</label>
      <label class="valueLabel">{{ entity.id.entityId }}</label>
      <label class="displayLabel">Project Name:</label>
      <label class="valueLabel projectNameLabel">{{ entity.projectName }}</label>
    </div>
    <div class="displayRow">
      <label class="displayLabel">Unit Quantity:</label>
      <label class="valueLabel">{{ entity.unitQuantity }}</label>
      <label class="displayLabel">Estimated Quantity:</label>
      <label class="valueLabel">{{ estimatedQuantity() }}</label>
      <label class="displayLabel">Quantity Remaining:</label>
      <label class="valueLabel">
        {{ remainingQuantity() }}
        @if (remainingQuantity() > 0) {
          <mat-icon class="warningIcon" matSuffix
            matTooltip="Please provide an estimated release schedule for all units">
            warning
          </mat-icon>
        }
      </label>
    </div>
    <div class="buttonRow">
      <label class="titleLabel">Estimated Release Schedule</label>
      <button [disabled]="isBusy() || remainingQuantity() <= 0" matButton="text" (click)="addSchedule()" class="inputButton primary-button">
        <span>
          <mat-icon class="size-16">add</mat-icon>
          <label class="buttonLabel">Add Release</label>
        </span>
      </button>
      <span class="spacer"></span>
      <button [disabled]="isBusy()" matButton="elevated" (click)="cancel()" class="inputButton warn-button">
        <span>
          <mat-icon class="size-16">cancel</mat-icon>
          <label class="buttonLabel">Cancel</label>
        </span>
      </button>
      <button [disabled]="changesDisabled()" matButton="elevated" class="inputButton primary-button" (click)="save()">
        <span>
          <mat-icon class="size-16">save</mat-icon>
          <label class="buttonLabel">Save</label>
        </span>
      </button>
    </div>
    <div class="tableWrapper">
      <table mat-table [dataSource]="schedules" matSort class="paginatedTable bordered-table">
        <ng-container matColumnDef="edit">
          <th class="buttonCell" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let schedule">
            <button matButton="text" (click)="editSchedule(schedule)">
              <mat-icon class="size-16">edit</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th class="buttonCell" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let schedule">
            <button matButton="text" (click)="deleteSchedule(schedule)">
              <mat-icon class="size-16">delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="quantity">Quantity</th>
          <td mat-cell *matCellDef="let schedule">{{ schedule.quantity }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="shipDate" matTooltip="Requested Ship Date">Requested Date</th>
          <td mat-cell *matCellDef="let schedule">{{ schedule.shipDate }}</td>
        </ng-container>
        <ng-container matColumnDef="comments">
          <th class="commentsCell" mat-header-cell *matHeaderCellDef mat-sort-header="externalNotes">Comments</th>
          <td mat-cell *matCellDef="let schedule">{{ schedule.externalNotes }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
  <div class="disclaimerRow">
    Information entered here is only intended to assist IEC in long range planning.
    You will still need to use Encompass to generate releases as needed.
  </div>
</div>
